import { isEmpty } from 'lodash';

import { IAppError } from '@/types/response';

export default function getResponseErrorType(error, resError: IAppError): 'RESOLVE' | 'REJECT' | 'ERROR' {
  const { config: { url = '' } = { url: '' } } = error;
  let errorType: 'RESOLVE' | 'REJECT' | 'ERROR' = 'ERROR';

  const alwaysRejectPatterns: RegExp[] = [
    /^\/api\/partner\/auth\/login$/,
    /^\/api\/partner\/auth\/login\/app$/,
    /^\/api\/partner\/auth\/notification\/token$/,
    /^\/api\/partner\/consultation\/recent$/,
    /^\/api\/log$/,
    /^\/api\/chat\/business\/call\/voice$/,
    /^\/api\/v2\/contract\/customer\/.+$/,
    /^\/api\/v2\/contract\/customer\/[^/]+$/,
    /^\/api\/v2\/contract\/customer\/\d+\/\d+\/restart$/,
    /^\/api\/v1\/selfservice\/credit\/summary$/,
    /^\/api\/v1\/selfservice\/subscription$/,
    /^\/api\/v1\/selfservice\/subscription\/change$/,
    /^\/api\/partner\/auth\/subUser(\?.*)?$/,
    /^\/api\/v1\/selfservice\/payment\/method(\?paymentType=.*)?$/,
    /^\/api\/auth\/3rd\/login\/[^/]+\/app$/,
  ];

  if (alwaysRejectPatterns.some((pattern) => pattern.test(url))) {
    errorType = 'REJECT';
  } else if (isEmpty(resError)) {
    errorType = 'RESOLVE';
  }

  return errorType;
}
